export type IGetImageForViewImageModal = (
  modal: IjQueryElmOrHtmlElm,
  triggerElm: IjQueryElmOrHtmlElm
) => void;

export function _getImageForViewImageModal(
  modal: IjQueryElmOrHtmlElm,
  triggerElm: IjQueryElmOrHtmlElm
): void {
  // Origin Elements
  const $button = $(triggerElm);
  const $modal = $(modal);
  const imageUrl = $button.data('href');
  const title = $button.data('modal-title');
  // Modal Elements
  const $modalTitle = $modal.find('.modal-custom-title');
  const $modalImgElm = $modal.find('.modal-body .full-image');
  const $modalLoading = $modal.find('.loading');
  const $imageContainer = $modal.find('.image-container');

  // Grab info from data-modal-title inside the a tag, to place in the modal title
  $modalTitle.text(title);

  $modalImgElm.attr({
    alt: title,
    src: imageUrl,
  });

  $modalImgElm.off('load').on('load', () => {
    $modalLoading.addClass('hide').attr('aria-hidden', 'true');
    $imageContainer.removeClass('hide').attr('aria-hidden', 'false');
  });
}
